import { FixableCategory } from '../../types';
import { getFixForCategory } from '../../utils/fixUtils';

export const useGetFixAction = (category?: FixableCategory) => {
  if (!category) {
    return null;
  }
  return getFixForCategory(category);
};
